<template lang="pug">
markup-wrapper.__page-error
	.wrapper-text
		span.code {{ code }}
		span.tooltip {{ tooltip }}
		span.text
			slot
	.wrapper-image
		img(src="./angry.png" :alt="info")
</template>

<script>
import ExtLink from '@/components/ext/Link.vue';
import ExtButton from '@/components/ext/Button.vue';
import { Wrapper as MarkupWrapper } from '@/components/markup';

export default {
	components: {
		MarkupWrapper
	},
	props: {
		code: String | Number,
		tooltip: String,
		alt: String,
	},
	computed: {
		info () {
			return this.alt ? this.alt : this.code + ' - ' + this.tooltip;
		}
	},
	mounted () {
		if (this.$bar) {
			this.$bar.fail();
		}
	}
}
</script>

<style lang="scss">
.__page-error {
	.text {
		p {
			padding-bottom: 19px;
		}
	}
}
</style>

<style lang="scss" scoped>
.__page-error {
    position: relative;
    font-family: 'Open Sans',sans-serif;
	min-height: 402px;

	:after {
		content: '';
		height: 0;
		width: 0;
		clear: both;
	}

	.wrapper-text {
		width: 43%;
		z-index: 1;
		position: relative;
		padding-left: 5%;
	}

	.code {
		font-weight: 800;
		font-size: 190px;
		display: block;
		padding-left: 1%;
	}

	.tooltip {
		size: 283px 23px;
		font-weight: 300;
		font-size: 25px;
		padding-bottom: 23px;
		padding-left: 8%;
		display: block;
	}

	.code,
	.tooltip {
		color: rgba(0, 0, 0, 0.85);
		text-transform: uppercase;
	}

	.text {
		font-weight: 400;
		color: #666;
		font-size: 14px;
		line-height: 20px;
		padding-left: 8%;
		display: block;
	}

	.wrapper-image {
		width: 40%;
		position: absolute;
		left: 42%;
		top: 20px;
		height: 382px;

		img {
			width: auto;
			height: 100%;
		}
	}

}

</style>


// WEBPACK FOOTER //
// Error.vue?7586a2bd